import { render, staticRenderFns } from "./Error404Component.vue?vue&type=template&id=b000e496&scoped=true&"
import script from "./Error404Component.vue?vue&type=script&lang=js&"
export * from "./Error404Component.vue?vue&type=script&lang=js&"
import style0 from "./Error404Component.vue?vue&type=style&index=0&id=b000e496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b000e496",
  null
  
)

export default component.exports